import { NodeEnv } from 'gleblu-socket-api';
import Logger from 'js-logger';
import { applyMiddleware, createStore, Store } from 'redux';
import { composeWithDevTools } from 'redux-devtools-extension/developmentOnly';
import { createLogger } from 'redux-logger';
import { persistReducer, persistStore } from 'redux-persist';
import browserLocalStorage from 'redux-persist/lib/storage';
import createReduxPromiseListener from 'redux-promise-listener';
import reduxSaga from 'redux-saga';

import { createErrorAction } from './actions/error';
import reducers from './reducers/reducers';
import sagas from './sagas/sagas';

const persistConfig = {
  key: 'gleblu',
  storage: browserLocalStorage,
  whitelist: ['authentication', 'language'],
  debug: false,
};
const persistedReducer = persistReducer(persistConfig, reducers);
const logger = createLogger();

const sagaMiddleware = reduxSaga({
  onError: (error: Error) => {
    Logger.error(error.stack);
    store.dispatch(createErrorAction({ errorMessage: error.message }));
  },
});

const reduxPromiseListener = createReduxPromiseListener();

const middleWare =
  import.meta.env.MODE === NodeEnv.development || import.meta.env.MODE === NodeEnv.staging
    ? composeWithDevTools(applyMiddleware(logger, sagaMiddleware, reduxPromiseListener.middleware))
    : applyMiddleware(sagaMiddleware, reduxPromiseListener.middleware);

const store: Store = createStore(persistedReducer, {}, middleWare);
export { store };
export const persistor = persistStore(store);
export const promiseListener = reduxPromiseListener;
export type ReduxPromiseListener = typeof promiseListener;

sagaMiddleware.run(sagas);
